/**
 * Created by tomere on 28/12/2017.
 */
import {DISTRIBUTION_CONSTANTS} from '../../../../constants/distribution.constants';

export default class DistributionStatusComponent {
	constructor() {
		this.template = require('./distribution.status.view.html');
		this.controller = DistributionStatusController;
		this.bindings = {
			status: '<',
			description: '<',
			moreInfo: '<?'
		};
	}
}

DistributionStatusComponent.META = {
	name: 'distributionStatus'
};


class DistributionStatusController {
	constructor(JfFullTextService) {
		this.JfFullTextService = JfFullTextService;
	}
	$onInit(){
		if(!this.status) {
			this.status = DISTRIBUTION_CONSTANTS.DISTRIBUTION_STATUS[0];
		}
	}

	onStatusShowMoreDetailsClick(text) {
		this.JfFullTextService.showFullTextModal(text, this.status.label, 500);
	}
}

DistributionStatusController.$inject = [
	'JfFullTextService'
];



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/distributionStatus/distribution.status.component.js